import React, { useEffect, useState } from "react";
import "./JobDetail.css";
import { Row, Col, Menu, Button, Modal, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { BsFillEyeFill } from 'react-icons/bs';
import {
  getJobDetail,
  updateGig,
  deleteJob,
  clearJobDelSuccess,
  fetchFindMyMatches,
  updateJobsReset,
  getJobBidDetails,
} from "../../../redux/actions";
import { useLocation } from "react-router-dom";
import Loader from "../../../components/Loading/Loader";
import { PieChart } from "@opd/g2plot-react";
import moment from "moment";
import JobCard from "../../../components/JobCard/JobCard";
import history from "../../../routes/history";
import candidate_img from "../../../assets/img/becomeACandidate.png";
import { StarFilled } from "@ant-design/icons";
import TopAlert from "../../../components/TopNotification/TopAlert";
import CountCircle from "../../PostAJob/EmployerProfile/components/CountCircle/CountCircle";
import facilitynameicon from "../../../assets/img/facilitynameicon.png";
import { LoadingOutlined } from "@ant-design/icons";
import PrivateTagSkillListing from "../../../components/PrivateMarketComponents/PrivateTagSkillListing";
import { Rate, Breadcrumb } from "antd";
import DOMPurify from "dompurify";
import { setCookie,getRelativeTime,generateFinalUrl  } from "../../../shared/helpers";
import { getImageByStateCode } from "../../CompanyProfile/components/cloudinary";
import chatWhiteIcon from "../../../assets/img/chat_icon_white.png";
import ExperienceLevel from "../../SearchSkillListing/components/ExperienceLevelFilter/ExperienceLevelFilter";
import { DefaultRating } from "../../../assets/helpers";
import PrivateTag from "../../../assets/icons/PrivateTag.svg";
import backButton from "../../../assets/icons/backButton.svg";
import AiImage from "../../../assets/icons/AiImage.svg";
import ex_suitcase from '../../../assets/icons/ex_suitcase.png';
import AI_Suggested from  "../../../assets/img/AI_Suggested.png";
import { Link } from "react-router-dom";

export default function JobDetail() {
  const dispatch = useDispatch();
  const location = useLocation();
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const [dimensions, setDimensions] = useState(window.innerWidth);
  const [showmodal, setshowmodal] = useState(false);
  const [skillDetails, setSkillDetails] = useState();
  const [industryDetails, setIndustryDetails] = useState();
  const [isDisclaimer, setIsDisclaimer] = useState(false);
  const showBackButton = location.state?.fromSpecificRedirect;

  const handleBack = () => {
    history.goBack();
  };

  useEffect(() => {
    setDimensions(window.innerWidth);
  }, [window.innerWidth]);
  var color = ["#64cfcc", "#edcd6d", "#4a9eb7", "#cecece", "#be5e30"];
  var deletedColor = ["#7e7e7e", "#7e7e7e", "#7e7e7e", "#7e7e7e", "#7e7e7e"];
  var img = location.state?.img;
  var indraft = location.state?.indraft;
  var indeleted = location.state?.indeleted;
  var isDeleted = location.state?.isDeleted;

  const expiry_response = useSelector(
    (state) => state.manageJobsReducer.expiry_success
  );
  const loader = useSelector((state) => state.updateGigReducer.loading);

  const deljobsuccess = useSelector(
    (state) => state.manageJobsReducer.del_success
  );
  const delete_job_response = useSelector(
    (state) => state.manageJobsReducer.response
  );
  const jobs = useSelector((state) => state.manageJobsReducer.jobs);
  const updateSuccess = useSelector((state) => state.UpdateJobReducer.success);
  const countDetails = useSelector(
    (state) => state.manageJobsReducer.bidDetails
  );
 

  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [piePlot, setpiePlot] = useState();
  const [piePlot2, setpiePlot2] = useState();
  const [loading, setloading] = useState(false);
  const [deletedJob, setDeletedJob] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [fakeHook, setfakeHook] = useState(false);

  const jobdetails = useSelector(
    (state) => state.getJobDetailReducer.jobdetails
  );
   const getTopSkills = (skills = []) => {
     if (!Array.isArray(skills) || skills.length === 0) return [];
 
     return [...skills]
       .sort((a, b) => b.SkillPercent - a.SkillPercent) // Sort by SkillPercent descending
       .slice(0, 3) 
       .map((skill) => ({
         id: skill.Skills.SkillName,
         name: skill.Skills.SkillName,
       }));
   };
 
   const getArrayObject = (name = "", id = "") => {
     return [{ name, id }];
   };
   const getAsRequiredForQuery = ({
     regions,
     countries,
     cities,
     skills = [],
   }) => {
     let accumulatedFilters = {};
     const addFilterToUrl = (key, value) => {
       if (value !== undefined && value !== null) {
         let encodedValue;
 
         if (typeof value === "string" || typeof value === "number") {
           encodedValue = String(value).replace(/&/g, "-*");
         } else {
           encodedValue = JSON.stringify(value).replace(/&/g, "-*");
         }
 
         accumulatedFilters[key] = encodedValue;
       }
     };
     const checkRadioRegion =regions ? getArrayObject(
       regions?.RegionName,
       regions?.RegionId
     ):undefined;
     const checkRegionId = regions ? [regions?.RegionId]:undefined;
     const checkRadioCountry = countries?  getArrayObject(
       countries?.CountryName,
       countries?.CountryId
     ):undefined;
     const checkCountryId = countries?  [countries?.CountryId]:undefined;
     //  FOR CITY
    const checkRadioLoc =cities ? getArrayObject(cities?.Location, cities?.CityId):undefined;
    // const checkRadioLoc = getArrayObject(cities?.CityName, cities?.CityId);
     const checkCityId =cities ?  [cities?.CityId]:undefined;
 
     const checkRadioSkill = getTopSkills(skills);
     const checkSkillId = checkRadioSkill.map((el) => el.name);
     const skillsPercentages =skills.sort((a, b) => b.SkillPercent - a.SkillPercent).slice(0, 3).map((el) => el.SkillPercent);
 
     const values = [
       { key: "Region", value: checkRadioRegion },
       { key: "regionId", value: checkRegionId },
       { key: "Country", value: checkRadioCountry },
       { key: "countryId", value: checkCountryId },
       { key: "City", value: checkRadioLoc },
       { key: "cityId", value: checkCityId },
       { key: "Skill", value: checkRadioSkill },
       { key: "skillsId", value: checkSkillId },
       {key:'skillsPercentages',value: skillsPercentages},
       {key:'searchType', value: 'talAutoSuggested'},
      {key:'isTalentSuggestion',value: true}
     ];
     
     values.forEach((el) => addFilterToUrl(el.key, el.value));
     const path = generateFinalUrl("/query", accumulatedFilters);
      localStorage.setItem("talentSearchQuery", path);
     return path
   };
  const handleAISuggestion = () => {
const isRemote = jobdetails?.[0]?.WorkplacePolicy=="fully-remote"? true : false
localStorage.setItem("gigDetail", JSON.stringify(jobdetails?.[0]));
     const query = getAsRequiredForQuery({
       regions: isRemote ? undefined:jobdetails?.[0]?.Regions,
       countries: isRemote ? undefined:jobdetails?.[0]?.Countries,
       cities: isRemote ? undefined:jobdetails?.[0]?.Location,
       skills: jobdetails?.[0]?.JobOrders_Skills,
     });
     history.push(query)
   };

  useEffect(() => {
    dispatch(updateJobsReset());
    dispatch(
      getJobBidDetails(
        location.state?.id ?? window.location.pathname?.split("jobdetail/")[1]
      )
    );
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    setfakeHook(true);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (
      jobdetails[0]?.JobOrderStatuses?.JobOrderStatusName === "Deleted" ||
      jobdetails[0]?.JobOrderStatuses?.JobOrderStatusName === "Closed"
    ) {
      setDeletedJob(true);
    } else if (
      jobdetails[0]?.JobOrderStatuses?.JobOrderStatusName === "Published" ||
      jobdetails[0]?.JobOrderStatuses?.JobOrderStatusName === "Expired"
    ) {
      setDeletedJob(false);
    }
  }, [jobdetails]);

  useEffect(() => {
    dispatch(clearJobDelSuccess());
  }, [jobdetails]);

  useEffect(() => {
    if (delete_job_response.status == 200) {
      dispatch(
        getJobDetail(
          location.state.id ?? window.location.pathname?.split("jobdetail/")[1]
        )
      );
    }
  }, [delete_job_response]);

  useEffect(() => {
    dispatch(
      getJobDetail(
        location.state?.id ?? window.location.pathname?.split("jobdetail/")[1]
      )
    );
  }, [expiry_response, location.state]);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    if (
      jobdetails?.length !== 0 &&
      jobdetails[0]?.JobOrderStatuses?.JobOrderStatusName == "Expired"
    ) {
      setDays(0);
      setHours(0);
      setMinutes(0);
    }
  }, [jobdetails]);

  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  const extendExp = (gigId) => {
    var extendedDate = new Date();

    extendedDate.setMonth(extendedDate.getMonth() + 1);

    // dispatch(
    //   updateGig({
    //     ExpiryDate: expDate,
    //     id: location.state.id,
    //   })
    // );

    dispatch(
      updateGig({
        ExpiryDate: extendedDate.toISOString(),
        JobOrderStatusName: "Published",
        id: location?.state?.id,
      })
    );

    setloading(true);
  };

  useEffect(() => {
    if (jobdetails?.length !== 0) {
      // var timer = setInterval(() => {
      const now = moment.utc();
      const then = moment.utc(jobdetails[0]?.ExpiryDate, "YYYY-MM-DD hh:mm");
      const countdown = moment.utc(then - now);
      setDays(moment(then).diff(now, "days"));
      setHours(countdown.format("HH"));
      setMinutes(countdown.format("mm") % 60);
    }
  }, [jobdetails, seconds]);

  useEffect(() => {
    setTimeout(() => {
      setSeconds(seconds + 1);
    }, 10000);
  }, [seconds]);

  // useEffect(() => {
  //   if (deljobsuccess && delete_job_response.status == 200) {
  //     setDeletedJob(true);
  //   }
  // }, [deljobsuccess]);

  useEffect(() => {
    var dataArray = [];
    var dataArray2 = [];
    if (
      jobdetails?.length !== 0 &&
      jobdetails[0]?.JobOrders_Skills?.length !== 0
    ) {
      var dataArrayTemp = jobdetails[0]?.JobOrders_Skills;
      for (let i = 0; i < dataArrayTemp.length; i++) {
        if (
          dataArrayTemp[i].Skills === null ||
          dataArrayTemp[i].Skills?.SkillName === null
        ) {
          dataArrayTemp[i].Skills = {
            SkillName: "Others",
            SkillPercent: dataArrayTemp[i].SkillPercent,
          };
        }
      }

      // Calculate the sum of SkillPercent values
      let sum = 0;
      let count = 0;

      for (let i = 0; i < dataArrayTemp.length; i++) {
        const skill = dataArrayTemp[i];

        if (
          dataArrayTemp[i].SkillPercent === null ||
          dataArrayTemp[i].Skills?.SkillPercent === null
        ) {
          sum += dataArrayTemp[i]?.SkillPercent;
          count++;
        }
      }

      // Check if the sum is less than or not equal to 100
      if (sum !== 100 && count > 0) {
        // Calculate the remaining value needed to reach 100
        const remaining = 100 - sum;

        // Calculate the proportion to distribute among SkillPercent values
        const proportion = remaining / count;

        // Distribute the remaining value proportionally among SkillPercent values
        for (let i = 0; i < dataArrayTemp.length; i++) {
          const skill = dataArrayTemp[i];

          if (
            dataArrayTemp[i]?.SkillPercent === null ||
            dataArrayTemp[i].Skills?.SkillPercent === null
          ) {
            dataArrayTemp[i].SkillPercent += proportion;
          }
        }
      }
      dataArray = dataArrayTemp?.map((item, index) => {
        return {
          type: item?.Skills?.SkillName ?? item?.SkillName,
          value: jobdetails[0]?.JobOrders_Skills[index]?.SkillPercent
            ? jobdetails[0]?.JobOrders_Skills[index]?.SkillPercent
            : jobdetails[0]?.JobOrders_Skills[index]?.SkillPercent,
        };
      });
    }

    if (jobdetails?.length !== 0 && jobdetails[0]?.Industry?.length !== 0) {
      dataArray2 = jobdetails[0]?.Industry?.map((item) => {
        return {
          type: item?.IndustryName,
          value: item?.IndustryPercent,
        };
      });
    }
    var piePlotObj = {
      appendPadding: 5,
      data: dataArray,
      angleField: "value",
      colorField: "type",
      // radius: 0.7,
      radius: 1.0,
      height: 150,
      legend: false,
      color:
        deletedJob && !location.state?.fromTemplate === true
          ? deletedColor
          : color,
      label: {
        type: "inner",
        offset: "-30%",
        content: ({ percent }) => {},
        style: {
          fontSize: 14,
          textAlign: "center",
        },
      },
      interactions: [{ type: "element-active" }],
    };
    var piePlot2Obj = {
      // appendPadding: [10, 20 ,30, 40],
      appendPadding: 5,
      data: dataArray2,
      angleField: "value",
      colorField: "type",
      radius: 1.0,
      legend: false,
      height: 150,
      color:
        deletedJob && !location.state?.fromTemplate === true
          ? deletedColor
          : color,
      label: {
        type: "inner",
        offset: "-30%",
        content: ({ percent }) => {},
        style: {
          fontSize: 14,
          textAlign: "center",
        },
      },
      interactions: [{ type: "element-active" }],
    };

    setpiePlot(piePlotObj);
    setpiePlot2(piePlot2Obj);
  }, [jobdetails, deletedJob]);

  const DeleteJobHandler = () => {
    setshowmodal(true);
  };

  useEffect(() => {
    setSkillDetails(
      jobdetails[0]?.JobOrders_Skills.map((item) => {
        return {
          skillName: item?.Skills?.SkillName ?? item?.SkillName,
          SkillPercent: item?.SkillPercent,
          isDisable: true,
        };
      })
    );
  }, [jobdetails[0]]);

  const skillDesitySplit = JSON.stringify(skillDetails);

  useEffect(() => {
    setIndustryDetails(
      jobdetails[0]?.Industry?.map((item) => {
        return {
          industryName: item.IndustryName,
          industryPercent: item.IndustryPercent ? item.IndustryPercent : 0,
          isDisable: true,
        };
      })
    );
  }, [jobdetails[0]]);

  const EditJobHandler = () => {
    // return;
    let skillDetails = jobdetails[0]?.JobOrders_Skills.map((item) => {
      return {
        skillName: item?.Skills?.SkillName ?? item?.SkillName,
        SkillPercent: item?.SkillPercent,
        isDisable: true,
      };
    });

    let industryDetails = jobdetails[0]?.Industry?.map((item) => {
      return {
        industryName: item.IndustryName,
        industryPercent: item.IndustryPercent ? item.IndustryPercent : 0,
        isDisable: true,
      };
    });
    dispatch(updateJobsReset());
    if (!updateSuccess) {
      history.push({
        pathname: "/contract-gig",
        state: {
          Title: jobdetails[0]?.Title,
          FacilityName: jobdetails[0]?.FacilityName,
          Skills: skillDetails,
          Location: jobdetails[0]?.Location?.LocationWithCountry,
          Experience: jobdetails[0]?.ExperienceLevels,
          Industry: industryDetails,
          Id: jobdetails[0]?.JobOrderId,
          Description: jobdetails[0]?.Description,
          WorkAuthorization:
            typeof jobdetails[0]?.WorkAuthorization == "string"
              ? [jobdetails[0]?.WorkAuthorization]
              : jobdetails[0]?.WorkAuthorization,
          isTemplate: jobdetails[0]?.isTemplate,
          FromEdit: true,
          NotTemplate: true,
          JobOrderTypeName: jobdetails[0]?.JobOrderTypes?.JobOrderTypeName,
          PermanentJob:
            jobdetails[0]?.JobOrderTypes?.JobOrderTypeName == "Permanent"
              ? true
              : false,
          // IdealContractLengthName: jobdetails[0]?.IdealContractLengthName,
          IdealContractLengthName:
            jobdetails[0]?.IdealContractLength?.IdealContractLengthName,
          WorkPolicy: jobdetails[0]?.WorkplacePolicy,
          Role: jobdetails[0]?.Role,
          employerName: jobdetails[0]?.EmployerName,
          BudgetMin: jobdetails[0]?.BudgetMin,
          certificates: jobdetails[0].Certifications,
          img: img,
          from: "JobDetail",
          locobj: jobdetails[0]?.Cities,
          placeId: jobdetails[0]?.facilityRating?.placeId,
          openPositions: jobdetails[0]?.Position,
        },
      });
    }
  };

  // ************************ handle array to show levels of experience ************************************

  // {jobdetails[0]?.ExperienceLevels?.ExperienceLevelName}

  function listExperienceLevels(arr1) {
    if (Array.isArray(arr1[0]?.ExperienceLevels)) {
      const expLvlArr = arr1[0]?.ExperienceLevels?.sort(
        (a, b) => a.ExperienceLevelId - b.ExperienceLevelId
      ).map((item) => {
        return item.ExperienceLevelName;
      });
      const expLvlStr = expLvlArr.join(", ");
      return expLvlStr;
    } else {
      return arr1[0]?.ExperienceLevels?.ExperienceLevelName;
    }
  }

  // ****************************************************************************************************

  //********** convert encrypted html code to HTML tags **********
  var cache = {},
    character,
    e = document.createElement("div");

  const msgtxt = (html) => {
    return html?.replace(/([&][^&; ]+[;])/g, function (entity) {
      character = cache[entity];
      if (!character) {
        e.innerHTML = entity;
        if (e.childNodes[0])
          character = cache[entity] = e.childNodes[0].nodeValue;
        else character = "";
      }
      return character;
    });
  };
  //*********************************************//

  const findMatches = () => {
    const workAuthorizationMapping = {
      "US Resident/Citizen": 5,
      Citizen: 5,
      EAD: 9,
      "H1-B": 8,
    };

    const encodeURL = encodeURIComponent(jobdetails[0]?.JobOrderId);

    let countryIds = [];
    let countryObj = [];
    let regionObj = [];
    let regionIds = [];
    let cityObj = [];
    let cityIds = [];
    let expLevels = [];
    let Industry = [];
    let industryId = [];

    if (jobdetails[0].Location) {
      countryIds = [parseInt(jobdetails[0].Location.CountryId)];
      countryObj = [
        {
          name: jobdetails[0].Location.CountryName,
          id: jobdetails[0].Location.CountryId,
        },
      ];
      regionObj = [
        {
          name: jobdetails[0].Location.RegionName,
          id: jobdetails[0].Location.RegionId,
        },
      ];
      regionIds = [parseInt(jobdetails[0].Location.RegionId)];
      cityObj = [
        {
          name: jobdetails[0].Location.Location,
          ids: jobdetails[0].Location.CityId,
        },
      ];
      cityIds = [parseInt(jobdetails[0].Location.CityId)];
    }

    if (jobdetails[0].ExperienceLevels?.length) {
      expLevels = JSON.stringify(
        jobdetails[0].ExperienceLevels?.map((item) => item.ExperienceLevelName)
      );
    }

    if (jobdetails[0].Industry?.length) {
      Industry = jobdetails[0].Industry?.map((item) => ({
        name: item.IndustryName,
        id: item.IndustryName,
      }));
      industryId = jobdetails[0].Industry?.map((item) => item.IndustryName);
    }

    let workAuth = [];
    let workAuthIds = [];

    if (jobdetails[0].WorkAuthorization) {
      workAuth = jobdetails[0].WorkAuthorization.map((item) => ({
        name: item === "Citizen" ? "US Resident/Citizen" : item,
        id: workAuthorizationMapping[item],
      }));
      workAuthIds = workAuth.map((item) => item.id);
    }

    const queryParams = new URLSearchParams({
      skillListing_type: jobdetails[0].JobOrderTypes?.JobOrderTypeName,
      experience: expLevels,
      Industry: Industry.length > 0 ? JSON.stringify(Industry) : "",
      industryId: industryId.length > 0 ? JSON.stringify(industryId) : "",
      Country: countryObj.length > 0 ? JSON.stringify(countryObj) : "",
      countryId: countryIds.length > 0 ? JSON.stringify(countryIds) : "",
      Region: regionObj.length > 0 ? JSON.stringify(regionObj) : "",
      regionId: regionIds.length > 0 ? JSON.stringify(regionIds) : "",
      City: cityObj.length > 0 ? JSON.stringify(cityObj) : "",
      cityId: cityIds.length > 0 ? JSON.stringify(cityIds) : "",
      VisaName: workAuth.length > 0 ? JSON.stringify(workAuth) : "",
      VisaStatusId: workAuthIds.length > 0 ? JSON.stringify(workAuthIds) : "",
      isPrivateTalent: jobdetails?.[0]?.isPrivate,
      searchType: "Match",
    });

   

    history.push({
      pathname: `/findmatches/${encodeURL}`,
      state: {
        Id: jobdetails[0]?.JobOrderId,
        Title: jobdetails[0].skills.SkillName,
        jobdetails: jobdetails,
      },
      search: queryParams.toString(),
    });
  };

  // console.log("jobdetails in job detail sreen::", jobdetails);
  const handleOk = () => {
    dispatch(
      deleteJob({
        // id: jobdetails[0]._id,
        id: jobdetails[0].JobOrderId,
      })
    );
    setshowmodal(false);
    setIsDisclaimer(true);
    if (deljobsuccess && delete_job_response.status == 200) {
      setDeletedJob(true);
    }
    if (jobdetails?.JobOrderStatuses?.JobOrderStatusName == "Deleted") {
      setDeletedJob(true);
    }

    // history.push({
    //   pathname: "/joblisting"
    // })
    // setshowmodal(false);
  };

  const handleCancel = () => {
    setshowmodal(false);
  };
  
  return jobdetails[0]?.JobOrderId == undefined ||
    (location?.state?.id &&
      location?.state?.id != jobdetails[0]?.JobOrderId) ? (
    <Loader />
  ) : (
    <>
      {deljobsuccess && delete_job_response.status == 200 ? (
        <TopAlert
          display={"block"}
          title={"Gig successfully deleted"}
          type="success"
        />
      ) : null}

      <div className="jobdetail-main">
        {isDisclaimer && deljobsuccess && delete_job_response.status == 500 ? (
          <TopAlert
            display={"flex"}
            title={delete_job_response.message}
            type="warning"
          />
        ) : null}

        {expiry_response ? (
          <TopAlert
            display={"block"}
            title={"Gig expiry extended successfully"}
            type="success"
          />
        ) : null}

        <Modal
          onCancel={() => setshowmodal(false)}
          title="Delete this gig?"
          className="modalStyle"
          visible={showmodal}
          closable={false}
          footer={null}
          width={400}
          centered
        >
          <div className="jobcard-dlttxt">Do you want to delete this gig?</div>
          <div
            style={{
              marginTop: "40px",
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <Button
              className="jobcard-modalno"
              key="back"
              onClick={handleCancel}
            >
              No, go back
            </Button>
            <Button
              className="jobcard-modalyes"
              key="submit"
              type="primary"
              onClick={handleOk}
            >
              Yes, delete job
            </Button>
          </div>
        </Modal>

        <Row>
          <Col xs={24} sm={24} md={14} lg={14} xl={14} className="jobd-wb">
            {showBackButton && (
              <p
                onClick={handleBack}
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  textAlign: "center",
                  marginBottom: "0.2rem",
                }}
              >
                <img
                  src={backButton}
                  alt="back-button"
                  style={{ paddingLeft: "10px", width: "20px", height: "20px" }}
                />
                <span style={{ color: "#4054B2", paddingLeft: "10px" }}>
                  back
                </span>
              </p>
            )}
            <div style={{ width: "100%" }}>
              {dimensions > 769 ? (
                <div>
                  {location.state?.screen && (
                    <Breadcrumb separator=">">
                      <Breadcrumb.Item
                        className={`${
                          deletedJob && !location.state?.fromTemplate === true
                            ? "joblisting-card-grey"
                            : "joblisting-jobdet-title-BreadCrumb goback"
                        }`}
                        onClick={history.goBack}
                      >
                        {location.state?.screen}
                      </Breadcrumb.Item>
                      <Breadcrumb.Item style={{ color: "#bfbfb" }}>
                        {jobdetails[0]?.Title}
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  )}
                  <div className="joblisting-jobdet-title">
                    {jobdetails[0]?.Title}
                  </div>
                  {userProfile?.profile?.ProfessionCode === "IT" ? null : (
                    <Row
                      className={`${
                        deletedJob && !location.state?.fromTemplate === true
                          ? "joblisting-card-grey"
                          : "joblisting-jobdet-facility"
                      }`}
                    >
                      <div style={{ display: "flex" }}>
                        {
                          <div style={{ marginRight: "1%" }}>
                            <img
                              src={facilitynameicon}
                              alt="facilityicon"
                              style={{ width: "16px", height: "16px" }}
                            ></img>
                          </div>
                        }

                        <div className="joblisting-jobdet-facility">
                          {userProfile?.Professions?.ProfessionCode === "IT" ? (
                            <>
                              <Tooltip title={jobdetails[0]?.WorkplacePolicy}>
                                {jobdetails[0]?.WorkplacePolicy &&
                                  jobdetails[0]?.WorkplacePolicy?.slice(
                                    0,
                                    1
                                  ).toUpperCase() +
                                    jobdetails[0]?.WorkplacePolicy.slice(1)}
                              </Tooltip>
                            </>
                          ) : (
                            <Tooltip title={jobdetails[0]?.FacilityName}>
                              <div
                                className="Job-Title-Detail"
                                style={{
                                  width:
                                    jobdetails[0]?.FacilityName?.length > 55
                                      ? "400px"
                                      : null,
                                }}
                              >
                                {jobdetails[0]?.FacilityName}
                              </div>
                            </Tooltip>
                          )}
                          {jobdetails?.[0]?.isPrivate ? (
                            <span >
                              <img src={PrivateTag} alt="private" />
                            </span>
                          ) : null}
                        </div>
                      </div>
                      {userProfile?.Professions?.ProfessionCode ===
                      "IT" ? null : (
                        <Rate
                          className={`joblisting_star ${
                            deletedJob && !location.state?.fromTemplate === true
                              ? "joblisting-card-grey"
                              : "joblisting_star_color"
                          }`}
                          allowHalf
                          disabled
                          defaultValue={
                            jobdetails[0]?.FacilityName?.toLowerCase()?.includes(
                              "skillgigs"
                            )
                              ? 4.5
                              : jobdetails[0]?.facilityRating?.rating
                              ? jobdetails[0]?.facilityRating?.rating
                              : DefaultRating
                          }
                        />
                      )}
                      <div
                        className={`joblisting-rating ${
                          deletedJob && !location.state?.fromTemplate === true
                            ? "joblisting-card-grey"
                            : "joblisting_star_color"
                        }`}
                      >
                        {userProfile?.Professions?.ProfessionCode === "IT"
                          ? null
                          : jobdetails[0]?.facilityRating == null ||
                            jobdetails[0]?.facilityRating == undefined ||
                            !jobdetails[0]?.facilityRating ||
                            !jobdetails[0]?.facilityRating?.rating ||
                            jobdetails[0]?.facilityRating?.rating == 0
                          ? jobdetails[0]?.FacilityName?.toLowerCase()?.includes(
                              "skillgigs"
                            )
                            ? 4.2
                            : 3.5
                          : jobdetails[0]?.facilityRating?.rating}
                      </div>
                      {userProfile?.Professions?.ProfessionCode ===
                      "IT" ? null : (
                        <div className="joblisting-rating joblisting-sub">
                          {jobdetails[0]?.facilityRating == null ||
                          jobdetails[0]?.facilityRating == undefined ||
                          !jobdetails[0]?.facilityRating?.reviews ||
                          jobdetails[0]?.facilityRating?.reviews == 0
                            ? jobdetails[0]?.FacilityName?.toLowerCase()?.includes(
                                "skillgigs"
                              )
                              ? "(49)"
                              : null
                            : `(${jobdetails[0]?.facilityRating?.reviews})`}
                        </div>
                      )}
                    </Row>
                  )}
                </div>
              ) : null}
              <div className="job-grey">
                <JobCard
                  img={
                    // img
                    jobdetails[0]?.Regions?.Code !== null &&
                    jobdetails[0]?.Cities?.CityName !== null
                      ? getImageByStateCode(
                          jobdetails[0]?.Regions?.Code,
                          jobdetails[0]?.Cities?.CityName,
                          jobdetails[0]?.CompanyName
                        )
                      : candidate_img
                  }
                  budgetType={jobdetails[0]?.BudgetTypes?.BudgetTypeCode}
                  professionCode={userProfile?.Professions?.ProfessionCode}
                  isHCEmployer={
                    userProfile?.Professions?.ProfessionCode == "HC"
                  }
                  title={jobdetails[0]?.Title}
                  facilityname={jobdetails[0]?.FacilityName}
                  WorkplacePolicy={jobdetails[0]?.WorkplacePolicy}
                  budget={
                    jobdetails[0]?.BudgetMin?.$numberDecimal ??
                    jobdetails[0]?.BudgetMin ??
                    "Negotiable"
                  }
                  RegionCode={jobdetails[0]?.Regions?.Code}
                  CityName={jobdetails[0]?.Cities?.CityName}
                  rates={jobdetails[0]?.BudgetTypes?.BudgetTypeName}
                  jobdetpage={true}
                  cardFooter={false}
                  location={jobdetails[0]?.Location?.LocationWithCountry}
                  rating={jobdetails[0]?.facilityRating?.rating}
                  reviews={jobdetails[0]?.facilityRating?.reviews}
                  isDeleted={
                    deletedJob && !location.state?.fromTemplate === true
                  }
                  jobDetailScreenDimension={dimensions > 769 ? true : false}
                  jobDetailScreen={true}
                  created={jobdetails[0].Created}
                  isPrivate={jobdetails[0]?.isPrivate}
                  ExternalGigId={jobdetails[0]?.ExternalGigId}
                />
              </div>

              <div className="jobDetails">
                <div className="jobdetail-divider topDivider"></div>
                <div className="jobdetail-head jobdetail-font">
                  About the gig
                </div>
                {jobdetails[0]?.ExternalGigId == null ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: msgtxt(jobdetails[0]?.Description),
                    }}
                    className="jobdetail-des"
                  >
                    {}
                  </div>
                ) : (
                  <>
                    <div className="jobdetail-sm">{`${
                      jobdetails[0]?.FacilityName || "Facility"
                    } is seeking a ${jobdetails[0]?.Title || "Title"} for a ${
                      jobdetails[0]?.JobOrderTypes?.JobOrderTypeName || "N/A"
                    } job in ${
                      jobdetails[0]?.Location?.LocationWithCountry || "location"
                    }`}</div>
                    {userProfile?.Professions?.ProfessionCode == "HC" ? (
                      <Row>
                        <Col
                          span={8}
                          className="jobdetail-headleft1 jobdetail-sm"
                        >
                          Shift
                        </Col>
                        <Col
                          span={16}
                          className="jobdetail-sm jobdetail-headright"
                        >
                          {jobdetails[0]?.Shift || "N/A"}
                        </Col>
                      </Row>
                    ) : null}
                  </>
                )}

                {jobdetails[0]?.WorkplacePolicy !== "fully-remote" && (
                  <Row>
                    <Col span={12} className="jobdetail-headleft1 jobdetail-sm">
                      Location
                      {/* hkjznknskxsak */}
                    </Col>
                    <Col span={12} className="jobdetail-sm jobdetail-headright">
                      {jobdetails[0]?.Location?.LocationWithCountry}
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col span={8} className="jobdetail-headleft1 jobdetail-sm">
                    Posted
                  </Col>
                  <Col span={16} className="jobdetail-sm jobdetail-headright">
                    {moment.utc(jobdetails[0]?.Created).format("MMMM DD, YYYY")}
                  </Col>
                </Row>
                <Row>
                  <Col span={8} className="jobdetail-headleft1 jobdetail-sm">
                    Expires
                  </Col>
                  <Col span={16} className="jobdetail-sm jobdetail-headright">
                    {moment
                      .utc(jobdetails[0]?.ExpiryDate)
                      .format("MMMM DD, YYYY")}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} className="jobdetail-headleft1 jobdetail-sm">
                    Job type
                  </Col>
                  <Col span={12} className="jobdetail-sm jobdetail-headright">
                    {jobdetails[0]?.JobOrderTypes?.JobOrderTypeName}
                  </Col>
                </Row>

                {(jobdetails?.length > 0 &&
                  jobdetails[0]?.JobOrderTypes?.JobOrderTypeName ==
                    "Contract") ||
                jobdetails[0]?.JobOrderTypes?.JobOrderTypeName ==
                  "Contract Gig" ? (
                  <Row>
                    <Col span={12} className="jobdetail-headleft1 jobdetail-sm">
                      Contract duration
                    </Col>
                    <Col span={12} className="jobdetail-sm jobdetail-headright">
                      {
                        jobdetails[0]?.IdealContractLength
                          ?.IdealContractLengthName
                      }
                    </Col>
                  </Row>
                ) : null}

                <Row>
                  <Col span={12} className="jobdetail-headleft1 jobdetail-sm">
                    Years of experience
                  </Col>
                  <Col span={12} className="jobdetail-sm jobdetail-headright">
                    {/* {jobdetails[0]?.ExperienceLevels?.ExperienceLevelName} */}
                    {listExperienceLevels(jobdetails)}
                  </Col>
                </Row>
                {jobdetails[0]?.WorkplacePolicy !== "fully-remote" && (
                  <Row>
                    <Col span={9} className="jobdetail-headleft1 jobdetail-sm">
                      Work authorization
                    </Col>
                    <Col span={15} className="jobdetail-sm jobdetail-headright">
                      <div className="work-authorization">
                        {jobdetails[0]?.WorkAuthorization
                          ? jobdetails[0]?.WorkAuthorization.map(
                              (res, index) => {
                                return ` ${res}${
                                  jobdetails[0]?.WorkAuthorization.length > 0 &&
                                  jobdetails[0]?.WorkAuthorization.length - 1 !=
                                    index
                                    ? ","
                                    : ""
                                }`;
                              }
                            )
                          : null}
                      </div>
                    </Col>
                  </Row>
                )}
               
                {userProfile?.Professions?.ProfessionCode === "IT" ? (
                  <div>
                    <Row>
                      <Col
                        span={12}
                        className="jobdetail-headleft1 jobdetail-sm"
                      >
                        Workplace policy
                      </Col>
                      <Col
                        span={12}
                        className="jobdetail-sm jobdetail-headright"
                      >
                        {jobdetails[0]?.WorkplacePolicy
                          ? jobdetails[0]?.WorkplacePolicy?.slice(
                              0,
                              1
                            ).toUpperCase() +
                            jobdetails[0]?.WorkplacePolicy.slice(1)
                          : jobdetails[0]?.WorkplacePolicy}
                      </Col>
                    </Row>
                    {jobdetails[0]?.Certifications?.length > 0 && (
                      <Row>
                        <Col
                          span={12}
                          className="jobdetail-headleft1 jobdetail-sm"
                        >
                          Certifications
                        </Col>
                        <Col
                          span={12}
                          className="jobdetail-sm jobdetail-headright"
                        >
                          {jobdetails?.length > 0 &&
                            jobdetails[0]?.Certifications?.length &&
                            jobdetails[0]?.Certifications?.map(
                              (item, index) => (
                                <div
                                  className="jobdetail-certifications"
                                  key="{item}"
                                >
                                  {item}
                                  {item ===
                                  jobdetails[0]?.Certifications?.slice(-1)[0]
                                    ? null
                                    : `${", "}`}
                                </div>
                              )
                            )}
                        </Col>
                      </Row>
                    )}{" "}
                    {/* Tax term */}
                    {userProfile?.Professions?.ProfessionCode === "IT" &&
                    jobdetails[0]?.IdealTerms !== null ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          paddingTop: "10px",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "400",
                            color: "#3E3E3E",
                          }}
                        >
                          Tax Term
                        </div>
                        <div>
                          {jobdetails[0]?.IdealTerms?.map((val, id) => {
                            return (
                              <span
                                className="jobdetail-headleft1 jobdetail-sm"
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "400",
                                  color: "#1E1E1E",
                                }}
                              >
                                {val}
                                {id !== jobdetails[0]?.IdealTerms?.length - 1 &&
                                  ", "}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : null}

                <div className="jobdetail-divider bottomDivider"></div>
                
              </div>
            </div>
           
      


            
          </Col>

          <Col xs={24} sm={24} md={10} lg={10} xl={10}>
            <div className="rightCol">
              {location.state?.fromTemplate == true ? null : (
                <div style={{ marginLeft: "3%", marginRight: "3%" }}>
                  {location.state?.fromChat == true && (
                    <div className="jobdetail-chat">
                      <button
                        className="jobdetail-match"
                        onClick={() =>
                          history.push({
                            pathname: "/conversations",
                            state: {
                              openConvo: true,
                              conversationId: location.state.conversationId,
                            },
                          })
                        }
                      >
                        Back to chat
                        <img className="chat-White-Icon" src={chatWhiteIcon} />
                      </button>
                    </div>
                  )}
                  {jobdetails?.length > 0 && jobdetails[0]?.Position ? (
                    // true?
                    <div className="jobdetail-OpenPositions-div">
                      <Row className="jobdetail-OpenPositions-Row">
                        {/* <Row > */}
                        <Col
                          span={12}
                          className="jobdetail-head jobdetail-font"
                        >
                          Total open positions
                        </Col>
                        <Col
                          span={4}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <div className="jobdetail-OpenPositions-div-count">
                            {jobdetails[0]?.Position}
                          </div>
                        </Col>
                      </Row>
                      <div className="jobdetail-divider"></div>
                      <div className={"nop-empty-div"}></div>
                    </div>
                  ) : null}

                  {indraft ? (
                    <Row
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "2%",
                      }}
                    >
                      <div className="jobdetail-deldraft">Draft</div>
                    </Row>
                  ) : indeleted ||
                    deletedJob ||
                    jobdetails[0]?.JobOrderStatuses?.JobOrderStatusName ==
                      "Closed" ? (
                    <Row className="deleted-job">
                      <div className="jobdetail-deldraft">
                        {jobdetails[0]?.JobOrderStatuses?.JobOrderStatusName ==
                        "Closed"
                          ? `Closed`
                          : jobdetails[0]?.JobOrderStatuses
                              ?.JobOrderStatusName === "Deleted"
                          ? `Deleted`
                          : null}
                      </div>
                    </Row>
                  ) : // new Date(`${jobdetails[0]?.ExpiryDate}`) < new Date() &&
                  jobdetails[0]?.JobOrderStatuses?.JobOrderStatusName !==
                      "Deleted" &&
                    jobdetails[0]?.JobOrderStatuses?.JobOrderStatusName ==
                      "Expired" ? (
                    // (jobdetails[0].JobOrderStatusName == "Expired" ?
                    <div className="jobdetail-contdiv-expired  jobdetail-contall">
                      <Row>
                        <Col
                          span={12}
                          className="jobdetail-head jobdetail-font"
                          style={{ marginTop: "2%" }}
                        >
                          Job expires in
                        </Col>
                        <Col span={4}>
                          <Row className="jobdetail-sm jobdetail-headright2">
                            0
                          </Row>
                          <Row className="jobdetail-headleft2 jobdetail-sm">
                            Days
                          </Row>
                        </Col>
                        <Col span={4}>
                          <Row className="jobdetail-sm jobdetail-headright2">
                            0
                          </Row>
                          <Row className="jobdetail-headleft2 jobdetail-sm">
                            Hours
                          </Row>
                        </Col>
                        <Col span={4}>
                          <Row className="jobdetail-sm jobdetail-headright2">
                            0
                          </Row>
                          <Row className="jobdetail-headleft2 jobdetail-sm">
                            Minutes
                          </Row>
                        </Col>
                      </Row>
                      {loading ? (
                        <button className="jobdetail-exp" onClick={() => {}}>
                          {loader ? (
                            <LoadingOutlined />
                          ) : (
                            "Expiry Extended Successfully"
                          )}
                        </button>
                      ) : (
                        <button
                          className="jobdetail-exp"
                          onClick={() => extendExp()}
                        >
                          {" "}
                          Republish Gig
                        </button>
                      )}
                    </div>
                  ) : location.state?.fromTemplate === true ? null : (
                    <div className="jobdetail-contdiv  jobdetail-contall">
                      <Row style={{ marginTop: "-0.3rem" }}>
                        {/* <Row > */}
                        <Col
                          span={12}
                          className="jobdetail-head jobdetail-font"
                        >
                          Gig expires in
                        </Col>
                        <Col span={4}>
                          <Row className="jobdetail-sm jobdetail-headright2">
                            {days}
                          </Row>
                          <Row className="jobdetail-headleft2 jobdetail-sm">
                            Days
                          </Row>
                        </Col>
                        <Col span={4}>
                          <Row className="jobdetail-sm jobdetail-headright2">
                            {hours}
                          </Row>
                          <Row className="jobdetail-headleft2 jobdetail-sm">
                            Hours
                          </Row>
                        </Col>
                        <Col span={4}>
                          <Row className="jobdetail-sm jobdetail-headright2">
                            {minutes}
                          </Row>
                          <Row className="jobdetail-headleft2 jobdetail-sm">
                            Mins
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  )}

                  <div className="jobdetail-divider"></div>
                </div>
              )}
              <div className="jobdetail-expbutpos">
                {location?.state?.fromTemplate === true ? null : (
                  <div className="jobdetail-contdiv2  jobdetail-contall">
                    <div className="jobdetail-head2 jobdetail-font">Stats</div>
                    {jobdetails[0]?.AutoLoaded !== null &&
                    jobdetails[0]?.BudgetMin > 0 ? (
                      <Row>
                        <Col
                          span={18}
                          className="jobdetail-headleft1 jobdetail-sm"
                        >
                          Suggested Rate
                        </Col>
                        <Col
                          span={6}
                          className="jobdetail-sm jobdetail-headright"
                        >
                          $
                          {jobdetails[0]?.BudgetMin && jobdetails[0]?.BudgetMin}
                          {/* {
                            // (jobdetails[0]?.maxbid_BudgetType &&
                            //       "/" + jobdetails[0]?.maxbid_BudgetType) ??
                            (jobdetails[0]?.BudgetTypes?.BudgetTypeName &&
                              "/" +
                                jobdetails[0]?.BudgetTypes?.BudgetTypeName) ??
                              ""
                          } */}
                          {jobdetails[0]?.JobOrderTypes?.JobOrderTypeName ==
                          "Permanent"
                            ? " Yearly"
                            : " Hourly"}
                        </Col>
                      </Row>
                    ) : null}
                    <Row>
                      <Col
                        span={18}
                        className="jobdetail-headleft1 jobdetail-sm"
                      >
                        Max bid sent
                      </Col>
                      <Col
                        span={6}
                        className="jobdetail-sm jobdetail-headright"
                      >
                        $
                        {countDetails?.maxbid?.$numberDecimal
                          ? // ? Math.floor(countDetails?.maxbid?.$numberDecimal)
                            countDetails?.maxbid?.$numberDecimal?.toLocaleString(
                              "en-US"
                            )
                          : countDetails?.maxbid?.toLocaleString("en-US")}
                        {countDetails?.maxbid !== 0 &&
                          `/${
                            ((countDetails?.maxbid_BudgetType &&
                              countDetails?.maxbid_BudgetType === "hr") ||
                            countDetails?.maxbid_BudgetType === "hour"
                              ? "HR"
                              : countDetails?.maxbid_BudgetType === "yr" ||
                                countDetails?.maxbid_BudgetType === "Year"
                              ? "YR"
                              : countDetails?.maxbid_BudgetType === "Week" ||
                                countDetails?.maxbid_BudgetType === "wk"
                              ? "WK"
                              : "yr") ??
                            ((countDetails?.BudgetTypes?.BudgetTypeName &&
                              "/" +
                                countDetails?.BudgetTypes?.BudgetTypeName ===
                                "hr") ||
                            countDetails?.BudgetTypes?.BudgetTypeName === "hour"
                              ? "HR"
                              : countDetails?.BudgetTypes?.BudgetTypeName ===
                                  "yr" ||
                                countDetails?.BudgetTypes?.BudgetTypeName ===
                                  "Year"
                              ? "YR"
                              : countDetails?.BudgetTypes?.BudgetTypeName ===
                                  "Week" ||
                                countDetails?.BudgetTypes?.BudgetTypeName ===
                                  "wk"
                              ? "WK"
                              : "yr") ??
                            ""
                          }`}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        span={20}
                        className="jobdetail-headleft1 jobdetail-sm"
                      >
                        Total bids sent
                      </Col>
                      <Col
                        span={4}
                        className="jobdetail-sm jobdetail-headright"
                      >
                        {countDetails?.totalbids}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        span={20}
                        className="jobdetail-headleft1 jobdetail-sm"
                      >
                        Total job views
                      </Col>
                      <Col
                        span={4}
                        className="jobdetail-sm jobdetail-headright"
                      >
                        {jobdetails[0]?.views?.length ?? 0}
                      </Col>
                    </Row>
                  </div>
                )}

                <div className="jobdetail-divider"></div>
                {jobdetails?.length > 0 &&
                  jobdetails[0]?.JobOrders_Skills?.length > 0 && (
                    <div className="jobdetail-contdiv3 jobdetail-contall">
                      <Row className="jobdetail-col">
                        <Col className="jobdetail-head2 jobdetail-font">
                          Skill density
                        </Col>
                        {location.state?.fromTemplate == true ||
                        jobdetails[0]?.JobOrderStatuses?.JobOrderStatusName ==
                          "Deleted" ||
                        jobdetails[0]?.JobOrderStatuses?.JobOrderStatusName ==
                          "Closed" ? null : (
                          <Link
                            to={{
                              pathname: "/contract-gig",
                              state: {},
                              search: `Title=${encodeURIComponent(
                                jobdetails[0]?.Title
                              )}&FacilityName=${
                                jobdetails[0]?.FacilityName
                              }&FromEdit=${true}&Location=${
                                jobdetails[0]?.Location?.LocationWithCountry
                              }&Experience=${JSON.stringify(
                                jobdetails[0]?.ExperienceLevels
                              )}&IdealContractLengthName=${
                                jobdetails[0]?.IdealContractLength
                                  ?.IdealContractLengthName
                              }&JobOrderTypeName=${
                                jobdetails[0]?.JobOrderTypes?.JobOrderTypeName
                              }&Skills=${JSON.stringify(
                                skillDetails
                              )}&Description=${
                                jobdetails[0]?.Description
                              }&WorkAuthorization=${JSON.stringify(
                                jobdetails[0]?.WorkAuthorization
                              )}&openPositions=${
                                jobdetails[0]?.Position
                              }&certificates=${JSON.stringify(
                                jobdetails[0].Certifications
                              )}&locobj=${jobdetails[0]?.Cities}&Id=${
                                jobdetails[0]?.JobOrderId
                              }&NotTemplate=${true}&Industry=${JSON.stringify(
                                industryDetails
                              )}&WorkPolicy=${
                                jobdetails[0]?.WorkplacePolicy
                              }&IdealTerms=${JSON.stringify(
                                jobdetails[0]?.IdealTerms
                              )}`,
                            }}
                          >
                            <Col
                              className="jobdetail-edit-btn"
                              // onClick={() => EditJobHandler()}
                            >
                              Edit skill density
                            </Col>
                          </Link>
                        )}
                      </Row>
                      <Row>
                        {/*                   
  <div className={isDeleted ? 'density-Row-Deleted' : null}></div> */}
                        <Col xs={12} lg={6} sm={8}>
                          {piePlot ? <PieChart {...piePlot} /> : null}

                          {/* </Col> */}
                        </Col>
                        <Col
                          xs={12}
                          lg={18}
                          sm={15}
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <div
                            style={{
                              marginTop: "40px",
                              width: "10rem",
                              marginRight: "20%",
                            }}
                          >
                            {jobdetails?.length > 0 &&
                              jobdetails[0]?.JobOrders_Skills?.map(
                                (item, index) => (
                                  <Row
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      flexWrap: "inherit",
                                    }}
                                    key={index}
                                  >
                                    <Col>
                                      <div
                                        style={{
                                          background:
                                            deletedJob &&
                                            !location.state?.fromTemplate ===
                                              true
                                              ? deletedColor[index]
                                              : color[index % color.length],
                                          width: "30px",
                                          height: "10px",
                                        }}
                                      ></div>
                                    </Col>
                                    <Col style={{ marginLeft: "5px" }}>
                                      <Tooltip title={item?.Skills?.SkillName}>
                                        <div className="Job-Title-Detail">
                                          {item?.Skills?.SkillName ??
                                            item?.SkillName}
                                        </div>
                                      </Tooltip>
                                    </Col>
                                  </Row>
                                )
                              )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  )}
                {userProfile?.Professions?.ProfessionCode === "IT" &&
                jobdetails &&
                jobdetails?.length &&
                jobdetails[0]?.Industry &&
                jobdetails[0]?.Industry?.length &&
                jobdetails[0]?.Industry[0]?.IndustryName ? (
                  <div>
                    <div className="jobdetail-divider"></div>
                    {jobdetails?.length > 0 &&
                      jobdetails[0]?.Industry?.length > 0 && (
                        <div className="jobdetail-contdiv3 jobdetail-contall">
                          <Row className="jobdetail-col">
                            <Col className="jobdetail-head2 jobdetail-font">
                              Industry density
                            </Col>
                            {location.state?.fromTemplate == true ||
                            jobdetails[0]?.JobOrderStatuses
                              ?.JobOrderStatusName == "Deleted" ||
                            jobdetails[0]?.JobOrderStatuses
                              ?.JobOrderStatusName == "Closed" ? null : (
                              <Link
                                to={{
                                  pathname: "/contract-gig",
                                  state: {},
                                  search: `Title=${encodeURIComponent(
                                    jobdetails[0]?.Title
                                  )}&FacilityName=${
                                    jobdetails[0]?.FacilityName
                                  }&FromEdit=${true}&Location=${
                                    jobdetails[0]?.Location?.LocationWithCountry
                                  }&Experience=${JSON.stringify(
                                    jobdetails[0]?.ExperienceLevels
                                  )}&IdealContractLengthName=${
                                    jobdetails[0]?.IdealContractLength
                                      ?.IdealContractLengthName
                                  }&JobOrderTypeName=${
                                    jobdetails[0]?.JobOrderTypes
                                      ?.JobOrderTypeName
                                  }&Skills=${encodeURIComponent(
                                    skillDesitySplit
                                  )}&WorkAuthorization=${JSON.stringify(
                                    jobdetails[0]?.WorkAuthorization
                                  )}&openPositions=${
                                    jobdetails[0]?.Position
                                  }&certificates=${JSON.stringify(
                                    jobdetails[0].Certifications
                                  )}&locobj=${jobdetails[0]?.Cities}&Id=${
                                    jobdetails[0]?.JobOrderId
                                  }&NotTemplate=${true}&Industry=${JSON.stringify(
                                    industryDetails
                                  )?.replace(/&/g, "ampersandd")}&WorkPolicy=${
                                    jobdetails[0]?.WorkplacePolicy
                                  }&Description=${
                                    jobdetails[0]?.Description
                                  }&IdealTerms=${JSON.stringify(
                                    jobdetails[0]?.IdealTerms
                                  )}`,
                                }}
                              >
                                <Col
                                  className="jobdetail-edit-btn"
                                  // onClick={() => EditJobHandler()}
                                >
                                  Edit industry density
                                </Col>
                              </Link>
                            )}
                          </Row>
                          <Row>
                            <Col xs={12} lg={6} sm={8}>
                              {piePlot2 ? <PieChart {...piePlot2} /> : null}
                            </Col>
                            <Col
                              xs={12}
                              lg={18}
                              sm={15}
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <div
                                style={{
                                  marginTop: "40px",
                                  width: "10rem",
                                  marginRight: "20%",
                                }}
                              >
                                {jobdetails?.length > 0 &&
                                  jobdetails[0]?.Industry?.map(
                                    (item, index) => (
                                      <Row
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          flexWrap: "inherit",
                                        }}
                                      >
                                        <Col>
                                          <div
                                            style={{
                                              background:
                                                deletedJob &&
                                                !location.state
                                                  ?.fromTemplate === true
                                                  ? deletedColor[index]
                                                  : color[index % color.length],
                                              width: "30px",
                                              height: "10px",
                                            }}
                                          ></div>
                                        </Col>
                                        <Col style={{ marginLeft: "5px" }}>
                                          <Tooltip title={item?.IndustryName}>
                                            <div className="Job-Title-Detail">
                                              {item?.IndustryName}
                                            </div>
                                          </Tooltip>
                                        </Col>
                                      </Row>
                                    )
                                  )}
                              </div>
                            </Col>
                          </Row>
                        </div>
                      )}
                  </div>
                ) : null}
                <div className="Ai-Suggest-mobile-view">
                <div className="ai-suggest">
        <div style={{display:'flex'}}>
  <img src={AiImage} alt="candidate" className="Ai-image-suggest"/>
  <div 
       className="ai-suggested-main">
  <span style={{ paddingLeft: '10px', fontSize: '18px' }}>Suggested Talents</span>
<span className="ai-suggested-count"><CountCircle  /></span>
  <span style={{fontSize:'14px',color:'#4054B2',cursor:'pointer'}} onClick={() => handleAISuggestion()}>See all</span>
  </div>
  </div>
  <div
  className="Ai-grid"
    
  >
   
    {jobdetails[0]?.autoTalSuggested?.candidates?.map((candidate) => {
  const {
    Title,
    MinimumBid,
    MinimumBidType,
    fullName,
    profilePic,
    experience,
    rating,
    lastActive,
    isSkillListingIsPrivate,
    prevviewed
  } = candidate;
  return (
    <div
    
      style={{
        border: 'solid 1px #e4e4e4',
        backgroundColor: '#fff',
        paddingBottom: '10px',
        cursor: 'pointer',
        borderRadius: '8px',
      }}
    >
      
       
      
      <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '10px' }}>
      {isSkillListingIsPrivate && (
  <div style={{ paddingLeft: '29px' }}>
    <PrivateTagSkillListing />
  </div>
)}
 
  <div
    className="img-containerr" 
    style={{ marginLeft: isSkillListingIsPrivate ? '0px' : '40px' }}
  >
   
              {
                profilePic &&
                !imageError &&
                profilePic?.split("/")?.pop() !== "no-pic.png" ? (
                  
                  <img
                      className='profile-imagee'
                      alt=""
                      src={`${process.env.REACT_APP_S3_URL}${profilePic?.charAt(0) !== "/" ? '/' : ""
                        }${profilePic}`}
                      onError={() => setImageError(true)}
                    />
                ) : (
                  <div className="img-textt">
                    {fullName ? fullName.charAt(0).toUpperCase() : "C"}
                  </div>
                )
              }
                  
         
  </div>
{
  prevviewed &&(
    <div style={{paddingRight:'20px'}}>
       <BsFillEyeFill
                          style={{
                            color: '#7e7e7e',
                            marginTop: '8px',
                            fontSize: '17px'
                          }}
                          onClick={(e) => e.stopPropagation()} />
    </div>
  )
}
  
</div>


    
      <div style={{ textAlign: 'center', padding: '10px' }}>
        <div style={{ fontWeight: 'bold' }}>{fullName}</div>

        
        {rating !== undefined && rating !== null && rating !== "" && (
  <div style={{ textAlign: 'center', lineHeight: '1.1', marginTop: '5px' }}>
    <Rate
      allowHalf
      disabled
      defaultValue={parseFloat(rating)}
      style={{ color: '#ffba08', fontSize: '14px' }}
    />
    <span style={{ fontSize: '12px', color: '#ffba08', marginTop: '2px',paddingLeft:'10px' }}>
      {parseFloat(rating).toFixed(1)}
     
     
    </span>
  </div>
)}

    
        <div style={{ marginTop: '5px' }}>{Title}</div>

        
        <div style={{ marginTop: '5px' }}>
  <span style={{ fontWeight: '500' }}>Desired Rate </span>
  <span>
    {MinimumBid
      ? `$${MinimumBid}${MinimumBidType === 'Year' ? '/YR' : MinimumBidType === 'Hour' ? '/HR' : '/WK'}`
      : '$Negotiable'}
  </span>
</div>

{experience && (
  <div style={{ fontSize: '12px', fontWeight: '500', marginTop: '5px' }}>
    <span role="img" aria-label="lock"> <img className="briefcase-img" src={ex_suitcase} alt="" />
      </span> {`${experience} of experience`}
  </div>
)}

        <div style={{ fontSize: '12px', marginTop: '5px' }}>
 Last active  {moment(lastActive).fromNow()}
        </div>
      </div>
    </div>
  );
})}

  </div>
</div>
</div>
                {location.state?.fromTemplate == true ? null : (
                  <div className="btnContainerr">
                    {indraft ? (
                      <button
                        className="jobdetail-edit"
                        onClick={() => EditJobHandler()}
                      >
                        Edit
                      </button>
                    ) : indeleted ||
                      (deletedJob &&
                        !location.state?.fromTemplate === true) ? null : (
                      <div>
                        {/* <button className={dimensions > 769 ? 'jobdetail-match' : 'jobdetail-match-mobile'}>Find Match</button> */}
                        <button
                          className="jobdetail-match"
                          onClick={() => findMatches()}
                        >
                          Find matches
                        </button>
                        <div className={dimensions < 769 ? "mergeBtns" : null}>
                          <button
                            style={{ width: dimensions < 769 ? "49%" : "100%" }}
                            className="jobdetail-edit"
                            onClick={() => DeleteJobHandler()}
                          >
                            Delete gig listing
                          </button>
                          {/* <div style={{ width: "5%" }}></div> */}

                          <div
                            style={{
                              width: dimensions < 769 ? "49%" : "100%",
                            }}
                          >
                            <Link
                              to={{
                                pathname: "/contract-gig",
                                state: {
                                  Description: jobdetails[0]?.Description,
                                },
                                search: `Title=${encodeURIComponent(
                                  jobdetails[0]?.Title
                                )}&FacilityName=${
                                  jobdetails[0]?.FacilityName
                                }&FromEdit=${true}&Location=${
                                  jobdetails[0]?.Location?.LocationWithCountry
                                }&Experience=${JSON.stringify(
                                  jobdetails[0]?.ExperienceLevels
                                )}&IdealContractLengthName=${
                                  jobdetails[0]?.IdealContractLength
                                    ?.IdealContractLengthName
                                }&JobOrderTypeName=${
                                  jobdetails[0]?.JobOrderTypes?.JobOrderTypeName
                                }&Skills=${encodeURIComponent(
                                  skillDesitySplit
                                )}&WorkAuthorization=${JSON.stringify(
                                  jobdetails[0]?.WorkAuthorization
                                )}&openPositions=${
                                  jobdetails[0]?.Position
                                }&certificates=${JSON.stringify(
                                  jobdetails[0].Certifications
                                )}&locobj=${jobdetails[0]?.Cities}&Id=${
                                  jobdetails[0]?.JobOrderId
                                }&NotTemplate=${true}&Industry=${JSON.stringify(
                                  industryDetails
                                )?.replace(/&/g, "ampersandd")}&WorkPolicy=${
                                  jobdetails[0]?.WorkplacePolicy
                                }&Description=${
                                  jobdetails[0]?.Description
                                }&IdealTerms=${JSON.stringify(
                                  jobdetails[0]?.IdealTerms
                                )}`, //encoded the skill density array because of special characters
                                // search: `Title=${encodeURIComponent(jobdetails[0]?.Title)}&FacilityName=${jobdetails[0]?.FacilityName}&FromEdit=${true}&Location=${jobdetails[0]?.Location?.LocationWithCountry}&Experience=${JSON.stringify(jobdetails[0]?.ExperienceLevels)}&IdealContractLengthName=${jobdetails[0]?.IdealContractLength?.IdealContractLengthName}&JobOrderTypeName=${jobdetails[0]?.JobOrderTypes?.JobOrderTypeName}&Skills=${encodeURIComponent(skillDesitySplit)}&WorkAuthorization=${JSON.stringify(jobdetails[0]?.WorkAuthorization)}&openPositions=${jobdetails[0]?.Position}&certificates=${JSON.stringify(jobdetails[0].Certifications)}&locobj=${jobdetails[0]?.Cities}&Id=${jobdetails[0]?.JobOrderId}&NotTemplate=${true}&Industry=${JSON.stringify(industryDetails)?.replace(/&/g, 'ampersandd')}&WorkPolicy=${jobdetails[0]?.WorkplacePolicy}&Description=${jobdetails[0]?.Description}&IdealTerms=${JSON.stringify([1,2])}`  ,  //encoded the skill density array because of special characters
                              }}
                            >
                              <button
                                className="jobdetail-edit"
                                // onClick={() => EditJobHandler()}
                              >
                                Edit gig listing
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                
              </div>
            </div>
          </Col>
        </Row>
        <div className="Ai-suggest-web-view">
        <div className="ai-suggest">
        <div style={{display:'flex'}}>
  <img src={AiImage} alt="candidate" className="Ai-image-suggest"/>
  <div 
       className="ai-suggested-main">
  <span style={{ paddingLeft: '10px', fontSize: '18px' }}>Suggested Talents</span>
<span className="ai-suggested-count"><CountCircle  /></span>
  <span style={{fontSize:'14px',color:'#4054B2',cursor:'pointer'}} onClick={() => handleAISuggestion()}>See all</span>
  </div>
  </div>
  <div
  className="Ai-grid"
    
  >
   
    {jobdetails[0]?.autoTalSuggested?.candidates?.map((candidate) => {
  const {
    Title,
    MinimumBid,
    MinimumBidType,
    fullName,
    profilePic,
    experience,
    rating,
    lastActive,
    isSkillListingIsPrivate,
    prevviewed
  } = candidate;

  return (
    <div
    
      style={{
        border: 'solid 1px #e4e4e4',
        backgroundColor: '#fff',
        paddingBottom: '10px',
        cursor: 'pointer',
        borderRadius: '8px',
      }}
    >
      
       
      
      <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '10px' }}>
      {isSkillListingIsPrivate && (
  <div style={{ paddingLeft: '29px' }}>
    <PrivateTagSkillListing />
  </div>
)}
 
  <div
    className="img-containerr" 
    style={{ marginLeft: isSkillListingIsPrivate ? '7px' : '68px' }}
  >
   
              {
                profilePic &&
                !imageError &&
                profilePic?.split("/")?.pop() !== "no-pic.png" ? (
                  
                  <img
                      className='profile-imagee'
                      alt=""
                      src={`${process.env.REACT_APP_S3_URL}${profilePic?.charAt(0) !== "/" ? '/' : ""
                        }${profilePic}`}
                      onError={() => setImageError(true)}
                    />
                ) : (
                  <div className="img-textt">
                    {fullName ? fullName.charAt(0).toUpperCase() : "C"}
                  </div>
                )
              }
                  
         
  </div>
{
  prevviewed &&(
    <div style={{paddingRight:'20px'}}>
       <BsFillEyeFill
                          style={{
                            color: '#7e7e7e',
                            marginTop: '8px',
                            fontSize: '17px'
                          }}
                          onClick={(e) => e.stopPropagation()} />
    </div>
  )
}
  
</div>


    
      <div style={{ textAlign: 'center', padding: '10px' }}>
        <div style={{ fontWeight: 'bold' }}>{fullName}</div>

        
        {rating !== undefined && rating !== null && rating !== "" && (
  <div style={{ textAlign: 'center', lineHeight: '1.1', marginTop: '5px' }}>
    <Rate
      allowHalf
      disabled
      defaultValue={parseFloat(rating)}
      style={{ color: '#ffba08', fontSize: '14px' }}
    />
    <span style={{ fontSize: '12px', color: '#ffba08', marginTop: '2px',paddingLeft:'10px' }}>
      {parseFloat(rating).toFixed(1)}
     
     
    </span>
  </div>
)}

    
        <div style={{ marginTop: '5px' }}>{Title}</div>

        
        <div style={{ marginTop: '5px' }}>
  <span style={{ fontWeight: '500' }}>Desired Rate </span>
  <span>
    {MinimumBid
      ? `$${MinimumBid}${MinimumBidType === 'Year' ? '/YR' : MinimumBidType === 'Hour' ? '/HR' : '/WK'}`
      : '$Negotiable'}
  </span>
</div>

{experience && (
  <div style={{ fontSize: '12px', fontWeight: '500', marginTop: '5px' }}>
    <span role="img" aria-label="lock"> <img className="briefcase-img" src={ex_suitcase} alt="" />
      </span> {`${experience} of experience`}
  </div>
)}

        <div style={{ fontSize: '12px', marginTop: '5px' }}>
 Last active  {moment(lastActive).fromNow()}
        </div>
      </div>
    </div>
  );
})}

  </div>
</div>
</div>
      </div>
      
    </>
  );
}
